module.exports = __webpack_public_path__ + "static/Carly_Daniel13-68b1d6a69f52a06b9302ab7fabf22d4c.jpg";